// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import Heading from 'components/atoms/Heading';
// import logoImg from 'assets/images/logo-white.svg';
import bgImg from 'assets/images/bg-img03.jpg';
import { useNavigate } from 'react-router-dom';
import Button from 'components/atoms/Button';
import { useContext } from 'react';
import { AuthContext } from 'context/authContext';
import { TemplateHolder, SubTitle, FormHolder, FormContent, ImgHolder } from './LoginTemplate.styles';

function LoginTemplate({ children, title, subtitle, withLogout, backButton }) {
  const { onLogout } = useContext(AuthContext);
  const navigate = useNavigate();
  return (
    <TemplateHolder>
      <ImgHolder
        css={`
          background-image: url(${bgImg});
        `}>
        {/* <img src={logoImg} alt="Plastk" /> */}
      </ImgHolder>
      <FormHolder>
        <FormContent>
          {backButton && (
            <Button
              onClick={() => {
                navigate('/');
              }}
              css={`
                align-self: flex-start;
                margin-bottom: 25px;
              `}
              prefix={<i className="material-icons-outlined">chevron_left</i>}
              type="primary"
              width={150}>
              Go Back
            </Button>
          )}
          {title && <Heading level={1}>{title}</Heading>}
          {subtitle && <SubTitle>{subtitle}</SubTitle>}
          {children}
          {withLogout && (
            <Button
              onClick={() => {
                onLogout();
              }}
              css="margin-top: 40px;"
              width={115}
              type="primary"
              prefix={<i className="material-icons-outlined">logout</i>}>
              Logout
            </Button>
          )}
        </FormContent>
      </FormHolder>
    </TemplateHolder>
  );
}

export default LoginTemplate;
